import script from "./AddEmploye.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEmploye.vue?vue&type=script&setup=true&lang=js"

import "./AddEmploye.vue?vue&type=style&index=0&id=677eb63d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-677eb63d"]])

export default __exports__